import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../material-components.module';
import { DefaultMatCalendarRangeStrategy, MatRangeDateSelectionModel } from '@angular/material/datepicker';
import { MatCalendarHeaderWithPresetsComponent } from './presets.component';
import { MatCalendarHeaderModule } from '../header/header.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MatCalendarHeaderModule,
  ],
  providers: [DefaultMatCalendarRangeStrategy, MatRangeDateSelectionModel],
  declarations: [MatCalendarHeaderWithPresetsComponent],
  exports: [MatCalendarHeaderWithPresetsComponent]
})
export class MatCalendarWithPresetsModule {
}
